(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rosterChecking.controller:RosterCheckingCtrl
   *
   * @description
   *
   */
  angular
    .module('rosterChecking')
    .controller('RosterCheckingCtrl', RosterCheckingCtrl);

  function RosterCheckingCtrl(CommonMasterData, $sce, CommonLogicService,crewScheduleService, CommonFuelService) {
    var vm = this;
    vm.ctrlName = 'RosterCheckingCtrl';
    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        crewId: null,
        crewName: null,
        crewBase: null,
        crewStatus: null
      },
      masterList: {
        crewNameList: [],
        crewTypeList: [],
        crewBaseList: [],
        crewStatusList: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        isCrewNotSelected: false
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.submitSearch = function (params) {
      searchRosterChecking(params);
    };

    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

      if (flag === 'crewType') {
        vm.model.masterList.crewNameList = loadCrewList(searchParams.crewType);
        vm.model.searchCriteria.crewId = null;
      }

      if (flag == 'crewType' || flag == 'crewId') {
        if ((!!vm.model.searchCriteria.crewType && !!vm.model.searchCriteria.crewType.crewTypeCode)
          || !!vm.model.searchCriteria.crewId) {
          vm.model.masterList.isCrewNotSelected = false;
        } else {
          vm.model.masterList.isCrewNotSelected = true;
        }
      }
      if(flag == 'crewName'){
        vm.model.searchCriteria.crewId = searchParams.crewName.crewId;
      }
      if(flag == 'crewBase'){
        vm.model.searchCriteria.crewBase = searchParams.crewBase;
      }
      if(flag == 'crewStatus'){
        vm.model.searchCriteria.crewStatus = searchParams.crewStatus;
      }
      if(flag == 'crewId'){
        vm.model.masterList.crewNameList = [];
        vm.model.searchCriteria.crewName = null;
        vm.model.searchCriteria.crewType = null;
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    function searchRosterChecking(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var reportDesign = "roster_checking.rptdesign";

        var url = CommonLogicService.getReportUrl(reportDesign,
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }


    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      if (!!param.crewType && !!param.crewType.crewTypeCode) {
        searchParamMap["crewType"] = param.crewType.crewTypeCode;
      }
      if (!!param.crewId) {
        searchParamMap["crewId"] = param.crewId;
      }
      if (!!param.crewName && !!param.crewName.crewId) {
        searchParamMap["crewId"] = param.crewName.crewId;
      }
      if (!!param.crewBase) {
        searchParamMap["crewBase"] = param.crewBase.airPortCode;
      }
      if (!!param.crewStatus && param.crewStatus.value !== null) {
        searchParamMap["crewStatus"]= param.crewStatus.value;
      }
      return searchParamMap;
    }


    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid) {
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        return false;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
        if ((!!vm.model.searchCriteria.crewType && !!vm.model.searchCriteria.crewType.crewTypeCode)
          || (!!vm.model.searchCriteria.crewId)) {
          vm.model.masterList.isCrewNotSelected = false;
          return true;
        } else {
          vm.model.masterList.isCrewNotSelected = true;
          return false;
        }
      }
    }

    function loadCrewList(crewType) {
      var param = {};
      param.crewType = '';
      param.active = true;
      if (!!crewType) {
        param.crewType = crewType.crewTypeCode;
        CommonMasterData.loadCrewList(param,
          function (response) {
          vm.model.masterList.crewNameList = crewScheduleService.adaptCrewList(response);
          vm.model.searchCriteria.crewName = null;
        }, function () {
          console.log('Crew list retrieval error');
        });
      } else {
        vm.model.masterList.crewNameList = [];
        vm.model.searchCriteria.crewName = null;
      }
    };

    (function () {

      // crew type codes
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

     CommonMasterData.getCrewBaseList(function (crewBaseList) {
           vm.model.masterList.crewBaseList = crewBaseList;
       }, function () {
           console.log('Crew base list retrieval error');
       });
     vm.model.masterList.crewStatusList = CommonFuelService.getStatusList();
    })();
  }
}());
